export default __webpack_public_path__ + "static/Gotham-Bold-af770ac972e35b82590f24126cd0039d.woff2";